<!-- Enroll vehicles Device modal -->

<button type="button" class="btn btn-primary" id="openEnrollVehicles" [hidden]="true" data-toggle="modal"
  data-target="#enrollVehicles" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal fade" id="enrollVehicles" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title">{{headerText}}</h5>
        <button id="closeEnrollVehicles" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetEnrollVehicles(); resetVehicleBrandFilters()">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card bg-light p-2">
					<div class="input-group float-right search-box-width">
							<input type="text" class="form-control font-1rem" [(ngModel)]="searchKey" name="vinSearchInput"
									#vinSearchInput="ngModel" placeholder="Search VIN" maxlength="17">
							<div class="input-group-append">
									<button class="btn border maroon-bg" (click)="searchClicked()"><i class="fa fa-search"></i></button>
							</div>
							<button class="btn btn-outline-danger py-0 delete-button ml-2 black-border" (click)="resetSearch()" data-toggle="tooltip" data-placement="right" title="Reset Search">
									<i class="fa fa-times black-font"></i>
							</button>
					</div>
					<!-- <div>
						<small class="text-danger text-left" *ngIf="vinSearchInput.errors">
							<p class="mb-0" *ngIf="!vinSearchInput.errors.required">Invalid vin</p>
						</small>
					</div> -->
				</div>
        <div class="row">
          <div class="col-12 mb-3 table-responsive no-gutters">
            <table class="table table-striped tbl-scrollable">
              <thead class="thead-light">
                <tr>
                  <th scope="col" width="6%" class="text-center">
                  </th>
                  <th scope="col" width="9%"></th>
                  <th scope="col" width="25%">VIN</th>
                  <th *ngIf="!isEnrollWindow" scope="col" width="16%">Brand</th>
                  <th *ngIf="isEnrollWindow" scope="col" width="16%">
                    <select class="w-100" id="vehicleMake" name="vehicleMake" [(ngModel)]="selectedVehicleBrandFilters.make"
                      (ngModelChange)="handleMakeSelection(selectedVehicleBrandFilters.make)" #vehicleMake="ngModel">
                      <option [ngValue]="null">Brand</option>
                      <option [ngValue]="item" *ngFor="let item of vehicleBrandFilters.make;">{{item}}</option>
                    </select>
                  </th>
                  <th *ngIf="!isEnrollWindow" scope="col" width="15%">Model</th>
                  <th *ngIf="isEnrollWindow" scope="col" width="15%">
                    <select class="w-100" id="vehicleModel" name="vehicleModel" [(ngModel)]="selectedVehicleBrandFilters.model"
                      (ngModelChange)="handleModelSelection(selectedVehicleBrandFilters.model)"  #vehicleModel="ngModel">
                      <option [ngValue]="null">Model</option>
                      <option [ngValue]="item" *ngFor="let item of vehicleBrandFilters.model;">{{item}}</option>
                    </select>
                  </th>
                  <th *ngIf="!isEnrollWindow" scope="col" width="17%">Trim</th>
                  <th *ngIf="isEnrollWindow" scope="col" width="17%">
                    <select class="w-100" id="vehicleTrim" name="vehicleTrim" [(ngModel)]="selectedVehicleBrandFilters.trim"
                      (ngModelChange)="handleTrimSelection(selectedVehicleBrandFilters.trim)" #vehicleYear="ngModel">
                      <option [ngValue]="null">Trim</option>
                      <option [ngValue]="item" *ngFor="let item of vehicleBrandFilters.trim;">{{item}}</option>
                    </select>
                  </th>
                  <th *ngIf="!isEnrollWindow" scope="col" width="12%">Year</th>
                  <th *ngIf="isEnrollWindow" scope="col" width="12%">
                    <select class="w-100" id="vehicleYear" name="vehicleYear" [(ngModel)]="selectedVehicleBrandFilters.year"
                      (ngModelChange)="handleYearSelection(selectedVehicleBrandFilters.year)" #vehicleYear="ngModel">
                      <option [ngValue]="null">Year</option>
                      <option [ngValue]="item" *ngFor="let item of vehicleBrandFilters.year;">{{item}}</option>
                    </select>
                  </th>
                  <!-- <th scope="col" *ngIf="headerText=='Enroll Vehicles'" width="20%" class="px-0">Certificate Id</th> -->
                  <th scope="col" width="17%" class="">Enrollment<br>Status</th>
                </tr>
              </thead>
              <tbody *ngIf="vehicleList && vehicleList.length>0; else noVehicles"
                class="scroll-height-screenHeight hide-x-scroll">
                <tr *ngFor="let vehicle of vehicleList; let i = index">
                  <th scope="row" width="6%" class="text-center pr-0">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" name="enrollVehicleCheckbox" class="custom-control-input"
                        [checked]="isVehicleSelected(vehicle.vin)"
                        (change)="onVehicleSelectionChange($event.target.checked, vehicle)" id="enrollVehicle_{{i}}">
                      <label class="custom-control-label" for="enrollVehicle_{{i}}"></label>
                    </div>
                  </th>
                  <td width="9%" class="px-0 text-center">
                    <img class="vehicle-image-table" src="{{vehicle.logo}}" alt="{{vehicle.model}}" />
                  </td>
                  <td scope="row" width="25%">{{vehicle.vin}}</td>
                  <td scope="row" width="16%">{{vehicle.make}}</td>
                  <td width="15%"> {{vehicle.model}}</td>
                  <td width="17%"> {{vehicle.trimName}}</td>
                  <td width="12%" [ngClass]="vehicle.year ? '': 'text-center'"><span
                      *ngIf="vehicle.year; else valueNotAvailable">{{vehicle.year}}</span></td>
                  <!-- <td width="20%" *ngIf="headerText=='Enroll Vehicles'" >{{vehicle.oemCustomerId}}</td> -->
                  <td width="17%" class="">
                    <span *ngIf="vehicle.enrollmentStatus; else valueNotAvailable">
                      {{getVehicleEnrollmentStatus(vehicle) | customText}}
                    </span>
                  </td>                  
                </tr>
              </tbody>
            </table>
            <ng-template #valueNotAvailable>
              <span>-</span>
            </ng-template>
          </div>
          <div class="col-12 text-right" *ngIf="vehicleList && vehicleList.length>0;">
            <span *ngIf="previousPage != null" class="pointer" (click)="getPreviousPage()">
              << Previous</span>
                <span *ngIf="nextPage != null" class="pointer" (click)="getNextPage()">&nbsp;&nbsp;&nbsp;&nbsp;Next >>
                </span>
          </div>
        </div>
        <ng-template #noVehicles>
          <div class="row text-center my-5 text-muted no-gutters">
            <div class="col">
              <h3>No vehicle available</h3>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="resetEnrollVehicles(); resetVehicleBrandFilters()">CANCEL</button>

        <button type="button" class="btn btn-primary" [disabled]="!(vehicleList && vehicleList.length>0)"
          (click)="onVehicleSelection()">{{buttonText}}</button>
      </div>
    </div>
  </div>
</div>

<app-account-packages #accountPackageModal (cancelEmitter)="onCancelAccountPackages()" (submitEmitter)="onSubmitAccountPackages($event)" (backEmitter)="backAccountPackages()"></app-account-packages>

<app-enrollment-errors modalId="enrollmentErrorsModal" modalOpenButtonId="openEnrollmentErrorsModal" modalCloseButtonId="closeEnrollmentErrorsModal" 
  modalHeader="Failed Vehicle(s)"  [enrollmentErrors]="enrollmentErrors"></app-enrollment-errors>

<!-- Review Enrollment Vehicles Modal -->

<button type="button" class="btn btn-primary" id="openReviewEnrollmentVehicles" [hidden]="true" data-toggle="modal"
  data-target="#reviewEnrollmentVehicles" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal" id="reviewEnrollmentVehicles" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="reviewEnrollmentVehiclesTitle">{{reviewVehicleModalMessages.header}}</h5>
        <button type="button" id="closeReviewEnrollmentVehicles" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetEnrollVehicles()">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="selectedVehicles">
        <label class="mt-2">{{reviewVehicleModalMessages.message}}</label>
        <label *ngIf="reviewVehicleModalMessages.note" class="mt-1"><span class="text-muted font13-400">{{reviewVehicleModalMessages.note}}</span></label>
        <div class="row mt-2">
          <div class="col-6 py-1" *ngFor="let vehicle of selectedVehicles; let i = index">
            <div class="row">
              <div class="col-7 pr-0" [ngClass]="i % 2 != 0 ? 'offset-2' : ''">
                <small>{{vehicle.vin}}</small>
              </div>
              <div class="col-3 text-center">
                <small><i class="fas fa-times text-secondary pointer" data-toggle="tooltip" data-placement="right"
                    title="Remove" (click)="removeSelectedVehicle(i)"></i></small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <i class="fas fa-arrow-left maroon pointer font20 mr-auto" (click)="backReviewEnrollmentVehicles()"></i>
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetEnrollVehicles()">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" (click)="reviewVehiclesSubmit()">
          <span>OK</span>
        </button>
      </div>
    </div>
  </div>
</div>